import React from 'react'
import { Link } from "react-router-dom";

const RoadTransportation = () => {
    return (
        <>

            <div style={{ overflow: "hidden" }}>
                <section className="section-breadcrumb main-wrapper">
                    <div className="breadcrumb-area">
                        <div className="container">
                            <div className="breadcrumb-wrapper">
                                <nav className="breadcrumb">
                                    <Link className="breadcrumb-item" to="/">Home</Link>
                                    <span className="breadcrumb-item active" aria-current="page">Services</span>
                                </nav>
                                <h1 className="breadcrumb-title">View All Services</h1>
                            </div>
                            <div className="breadcrumb-bg-block">
                                <img src="assets/images/breadcrumb-bg.jpg" alt="breadcrumb-bg" width={1920} height={448} className="img-cover" />
                                <img src="assets/images/breadcrumb-shape.png" alt="breadcrumb-shape" width={1033} height={448} />
                            </div>
                        </div>
                    </div>
                </section>
                <div className="section-service-details">
                    <div className="section-space">
                        <div className="container">
                            <div className="row g-lg-5">
                                <div className="col-md-6 col-lg-7 col-xl-8">
                                    <div className="mb-4">
                                        <img src="assets/images/hero-2-slider-bg-3.webp" alt="service-details-hero-img" width={905} height={546} className="img-fluid rounded" />
                                    </div>
                                    <article className="text-rich">
                                        <h2>Truck Express Services</h2>
                                        <p>Rahul Logistics takes great satisfaction in providing superior logistics solutions that are customized to meet your unique needs. Our truck transportation services in Katni are designed to offer adaptable, economical, and efficient transportation options throughout India, guaranteeing that your cargo arrives at its destination promptly and safely.</p>
                                        <p> We provide Full Truck Load, Part Truck Load, and Speed Trucking services to suit your needs, whether you're a company managing large shipments or need speedy delivery options. </p>
                                        <p> With three primary trucking options—Full Truck Load (FTL), Part Truck Load (PTL), and Speed Trucking—Rahul Logistics' Truck Express offers complete logistics solutions. </p>
                                        <p> We provide nationwide protection while putting a significant emphasis on punctuality, security, and cost-effectiveness for organizations of all sizes and sectors. </p>
                                       
                                        <ul className="content-list content-list-1 flex-wrap d-flex row-gap-2 column-gap-5 flex-wrap">
                                            <li>On-Time Delivery</li>
                                            <li>Real-Time Tracking</li>
                                            <li>Competitive Pricing</li>
                                            <li>Nationwide Coverage </li>
                                            <li>Advanced Technology</li>
                                            <li>24/7 Customer Support</li>
                                            <li>Customer-Centric Approach</li>
                                        </ul>
                                    </article>
                                </div>
                                <div className="col-md-6 col-lg-5 col-xl-4">
                                    <aside>
                                        <ul className="sidebar-list">
                                            <li className="sidebar-banner">
                                                <img src="assets/images/sidebar-banner-img.jpg" alt="sidebar-banner-img" width={368} height={546} className="img-cover" />
                                                <div className="inner-content">
                                                    
                                                    <div className="service-banner-info-block">
                                                        <ul className="get-touch-info-list">
                                                            <li>
                                                                <div className="icon">
                                                                    <i className="fa-light fa-phone" />
                                                                </div>
                                                                <div className="content">
                                                                    <span>24/7 Our Support</span>
                                                                    <a href="tel:+91 8770252599" className="text-white">+91 8770252599</a>
                                                                </div>
                                                            </li>
                                                        </ul>
                                                    </div>
                                                </div>
                                            </li>
                                            {/* Sidebar Item - Banner*/}
                                        </ul>
                                    </aside>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

        </>
    )
}

export default RoadTransportation